module.exports = __webpack_public_path__ + "img/user_3.jpg";